CustomTC.define('jquery/var/class2type',[],function() {
	// [[Class]] -> type pairs
	return {};
});

